module.exports = __webpack_public_path__ + "img/animals.7028c87.webp";